import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FormToolsService } from '../../core';
import { Administrator, AdministratorService, AdministratorFormService } from '../shared';

@Component({
  selector: 'administrator-form',
  templateUrl: './administrator-form.component.html',
  styleUrls: ['./administrator-form.component.scss']
})
export class AdministratorFormComponent implements OnInit {
  @Input() id: string;
  @Output() onSave: EventEmitter<string> = new EventEmitter();
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();

  loading: boolean = false;
  form: FormGroup;

  constructor(
    private ft: FormToolsService,
    public dataService: AdministratorService,
    private formService: AdministratorFormService
  ) {}

  ngOnInit() {}

  ngOnChanges() {
    this.form = null;

    if (this.id) {
      this.loading = true;

      this.dataService
        .getById(this.id)
        .subscribe(item => {
          this.form = this.formService.getForm(item);
          this.loading = false;
        })
      ;
    } else {
      setTimeout(() => { this.form = this.formService.getForm(); }, 100);      
    } 
  }

  transformFormValueBeforeSave(form: FormGroup) {
    let value: Administrator = {
      name: form.value.name,
      email: form.value.email,
      role: form.value.role,
      active: form.value.active
    };

    if (form.value._id !== null) {
      value._id = form.value._id;
    }

    if ((form.get('passwordGroup').valid) && (form.get('passwordGroup').get('password').value != '')) {
      value.password = form.get('passwordGroup').get('password').value;
    }

    return value;    
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/administrators/administrator-form/administrator-form.component.ts